import type { Density } from "@homing/tokens";

export interface MessageRowProps {
  who: string;
  subject: string;
  snippet: string;
  when: string;
  unread?: boolean;
  selected?: boolean;
  checked?: boolean;
  starred?: boolean;
  density?: Density;
  labels?: string[];
  count?: number;
  /** stable id of the thread, exposed as data-id */
  rowId?: string;
  onClick?: () => void;
  onDoubleClick?: () => void;
}

export function MessageRow(p: MessageRowProps) {
  return (
    <div
      role="option"
      className="row chrome"
      aria-selected={p.selected ? "true" : "false"}
      data-unread={p.unread ? "" : undefined}
      data-checked={p.checked ? "" : undefined}
      data-density={p.density ?? "condensed"}
      data-id={p.rowId}
      onClick={p.onClick}
      onDoubleClick={p.onDoubleClick}
    >
      <span className="dot" aria-label={p.unread ? "unread" : undefined} />
      <span className="who">
        {p.who}
        {p.count && p.count > 1 ? <span className="muted num"> {p.count}</span> : null}
      </span>
      <span className="subj">
        {p.starred ? (
          <span className="star" aria-label="starred">
            ★{" "}
          </span>
        ) : null}
        <b style={{ fontWeight: "inherit" }}>{p.subject}</b>
        {p.density !== "minimal" ? <span className="snip"> — {p.snippet}</span> : null}{" "}
        {p.labels?.map((l) => (
          <span key={l} className="chip">
            {l}
          </span>
        ))}
      </span>
      <span className="when">{p.when}</span>
    </div>
  );
}
